import classNames from 'classnames';
import {ActionsRow, FixedDropDownButton, i18n} from 'mc/lib';
import PropTypes from 'prop-types';
import React, {PureComponent} from 'react';
import {Button, Card, CardBlock, CardHeader, DropdownItem} from 'reactstrap';
import {TypUcel} from '../../enums';
import Lokalita from './Lokalita';

export default class LokalitaList extends PureComponent {

    static propTypes = {
        druhUcelList: PropTypes.array.isRequired,
        lokalitaList: PropTypes.array.isRequired,
        onAdd: PropTypes.func,
        onEdit: PropTypes.func,
        onDelete: PropTypes.func,
    };

    renderLokalita = lokalita => {
        const {onEdit, onDelete} = this.props;
        return <Lokalita key={lokalita.id}
                         lokalita={lokalita}
                         onEdit={onEdit}
                         onDelete={onDelete}/>;
    };

    handleTypUcelClick = event => {
        this.props.onAdd(event.target.dataset.typUcel);
    };

    renderTypUcelItem = typUcel => {
        return (
            <DropdownItem key={typUcel} data-typ-ucel={typUcel} onClick={this.handleTypUcelClick}>
                {TypUcel.getCaption(typUcel)}
            </DropdownItem>
        );
    };

    renderActions() {
        const {druhUcelList, onAdd} = this.props;
        if (!onAdd) {
            return null;
        }

        const typUcelList = TypUcel.values.filter(typUcel => {
            return druhUcelList.some(druhUcel => druhUcel.typUcel === typUcel);
        });

        if (!typUcelList.length) {
            return null;
        }

        if (typUcelList.length === 1) {
            return (
                <Button data-typ-ucel={typUcelList[0]} onClick={this.handleTypUcelClick}>
                    {i18n('global.add')}
                </Button>
            );
        }

        return (
            <FixedDropDownButton title={i18n('global.add')}>
                {typUcelList.map(this.renderTypUcelItem)}
            </FixedDropDownButton>
        );
    }

    render() {
        const {lokalitaList} = this.props;
        return (
            <Card className={classNames('bordered', {'items-list': lokalitaList.length > 0})}>
                <CardHeader>
                    <ActionsRow actions={this.renderActions()}>
                        <h5>{i18n('lokalita.list')} ({lokalitaList.length})</h5>
                    </ActionsRow>
                </CardHeader>
                {lokalitaList.length === 0 && (
                    <CardBlock className="text-danger">{i18n('lokalita.emptyList')}</CardBlock>
                )}
                {lokalitaList.map(this.renderLokalita)}
            </Card>
        );
    }

}
